module.exports = __webpack_public_path__ + "img/ic_mpe_chair_sm3_normal.01f54557.png";